<template>
    <div class="main">
        <div class="title">
            帮助中心
        </div>
        <div class="help_content">
            <div class="help_item" v-for="(item , index) in helpList" :key="index" v-if="item.visible">
                <template v-if="item.href.substr(0, 4) === 'http' || item.href.substr(0, 2) === '//'">
                    <a :href="item.href">
                        <img class="cover alignM fl marginR8" style="width:24px;height:24px;" :src="item.img" alt="">
                        <span class="font_position">{{item.name}}</span>
                        <img class="icon_position" style="width:16px;height:16px;" src="icon/userIcon/help_right.png" alt="">
                    </a>
                </template>
                <template v-else>
                    <router-link :to="item.href">
                        <img class="cover alignM fl marginR8" style="width:24px;height:24px;" :src="item.img" alt="">
                        <span class="font_position">{{item.name}}</span>
                        <img class="icon_position" style="width:16px;height:16px;" src="icon/userIcon/help_right.png" alt="">
                    </router-link>
                </template>

            </div>
        </div>

    </div>
</template>
<script>
import externalApp from '@data/externalApp';

// data api
import userApi from '@/api/user';

// platform api and util
import consoleApi from '@/components/platformApi/consoleApi';

export default {
    data(){
        return{
            helpList:[
                {
                    img: 'icon/userIcon/relation_icon.png',
                    name:'在线咨询',
                    href:externalApp.oldShixun.baseUrl + 'html/me/contact.html',
                    visible : true
                },
                {
                    img: 'icon/userIcon/issue_icon.png',
                    name:'常见问题',
                    href:externalApp.oldShixun.baseUrl + 'html/me/faq.html',
                    visible : true
                },
                {
                    img: 'icon/userIcon/set_icon.png',
                    name:'设置',
                    // href:externalApp.oldShixun.baseUrl + 'html/me/set.html'
                    href: '/me/setting',
                    visible : true
                },
                {
                    img: 'icon/userIcon/profiles_icon.png',
                    name:'个人认证',
                    // href:externalApp.oldShixun.baseUrl + 'html/me/mydetails.html'
                    href : '/me/myProfile',
                    visible : false
                },{
                    img: 'icon/userIcon/profiles_icon.png',
                    name:'个人验证',
                    // href:externalApp.oldShixun.baseUrl + 'html/me/mydetails.html'
                    href : '/me/bindPhone',
                    visible : false
                },
                // {
                //     img: 'icon/userIcon/profiles_icon.png',
                //     name:'信息登记',
                //     href : '/me/registerInformation',
                //     visible : true
                // },
                // {
                //     img: 'icon/userIcon/profiles_icon.png',
                //     name:'地址管理',
                //     // href:externalApp.oldShixun.baseUrl + 'html/me/mydetails.html'
                //     href : '/shopping/myAddress',
                //     visible : true
                // },
                {
                    img: 'icon/userIcon/suggestion_icon.png',
                    name:'意见反馈',
                    href:'/help/feedback',
                    visible : true
                },
                // {
                //     img: 'icon/userIcon/business_icon.png',
                //     name:'城市合伙人',
                //     href: 'business/cooperate',
                //     visible : true
                // },
                {
                    img: 'icon/userIcon/business_icon.png',
                    name: '关于我们',  // 原名称：广告位商务合作
                    href: '/business/cooperate_for_ad',
                    visible : true
                },

            ]
        }
    },
    mounted() {
        // 个人认证检查手机号绑定情况
        userApi.getBindPhoneStatus((status) => {

            consoleApi.log('[user] 检查手机绑定状态：');
            if (status)
            {
                consoleApi.log('[user] -- 已绑定手机');
                return;
            }

            consoleApi.log('[user] -- 未绑定手机');
            this.helpList[4].visible = true;
        });
    }
}
</script>
<style lang="scss" scoped>
.main{
    //width:90%;
    margin:0 auto;
    background:#fff;
    margin-top: 16px;
    border-radius: 8px;
    padding: 0 16px;
    box-sizing: border-box;
}

.title{
    padding-top: 12px;
    font-size: 18px;

    font-weight: 600;
    color: #000;

}

.help_content{
    width: 100%;
    padding-bottom: 2px;
    .help_item{
        margin: 16px 0;
        width:100%;
        height: 24px;
        line-height: 24px;
        position: relative;
        .font_position{
            font-size: 14px;

            font-weight: 400;
            color: #333333;

        }
        .icon_position{
            position: absolute;
            top: 4px;
            right: 0px;
        }
    }
}


</style>
